/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "Merchant": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyPhotoUrl": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "readOnlyBusinessName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.Merchant) {
  $root.addJSON(jsonData);
}

/**
 * Information about a merchant / seller.
 *
 * SOURCE Merchant @ squareup/client/merchant.proto at 16:1
 */
export const Merchant = $root.lookupType('squareup.client.Merchant');
fixType(Merchant, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(Merchant);